import axios from "axios";

export const createProduct = (categoryId, data) =>
  axios
    .post("/api/ds-product", {
      op: "create",
      item: {
        categoryId,
        ...data
      }
    })
    .then(response => response.data)
    .catch(error => ({ success: false }));

export const listProducts = categoryId =>
  axios
    .post("/api/ds-product", {
      op: "list",
      categoryId,
      convert: true
    })
    .then(response => response.data)
    .catch(error => ({ success: false }));

export const getProduct = id =>
  axios
    .post("/api/ds-product", {
      op: "read",
      item: { id },
      convert: true
    })
    .then(response => response.data)
    .catch(error => ({ success: false }));

export const AddAttributeProductValue = (productId, attributeValues) =>
  axios
    .post("/api/add-product-attribute-values", {
      productId: parseInt(productId, 10),
      attributeValues
    })
    .then(response => response.data)
    .catch(error => ({ success: false }));

export const updateCategoryConfig = (categoryId, attributesOrder) =>
  axios
    .post("/api/save-category-config", {
      categoryId: categoryId,
      config: { attributesOrder }
    })
    .then(response => response.data)
    .catch(error => ({ success: false }));

export const getItemReservations = id =>
  axios
    .post("/api/get-item-reservations", {
      itemId: id
    })
    .then(response => response.data)
    .catch(error => ({ success: false }));



// WEBPACK FOOTER //
// ./src/modules/items/_api.js